import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';

export const FORM_FIELD = {
  NAME: {
    name: 'title',
    label: 'Channel name:',
    placeholder: 'Enter a name',
    rules: [{ required: true, message: 'Name is required' }],
  },
  LOGO: {
    name: 'logo',
    label: 'Logo:',
    buttonText: 'CHOOSE A NEW LOGO',
    size: IMAGE_SIZE['300x75'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  URL: {
    name: 'url',
    label: 'URL:',
    placeholder: 'Enter a url',
    rules: [
      { type: 'url', message: "Doesn't look like a valid URL" },
      { required: true, message: 'URL is required' },
    ],
  },
  COUNTRY: {
    name: 'countryName',
    serialize: (field, values) => {
      return { countryName: values.countryName.name, countryId: values.countryName.id };
    },
    deserialize: (field, serverData) => {
      const id = serverData.countryId;
      const name = serverData.countryName;

      return { [field.name]: { id, name } };
    },
  },
  COUNTRY_ID: {
    name: 'countryId',
  },
};
